/*
 * Form Text
 */
import { Component, registerComponent } from 'js/component.js';
import { sendFormStartEvent } from 'js/dataLayer.js';
const componentName = 'form-text';

export class FormText extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        parentForm: this.element.closest('form'),
        textInput: this.element.querySelector(`input.${componentName}__input`),
        textArea: this.element.querySelector(`textarea.${componentName}__textarea`),
        label: this.element.querySelector('label')
    };

    // Util & State
    currentValue = this.elements.textInput ? this.elements.textInput.value : this.elements.textArea.value;
    isRequired = () => {
        if(this.elements.textInput && this.elements.textInput.getAttribute('data-required') !== null) return true;
        if(this.elements.textArea && this.elements.textArea.getAttribute('data-required') !== null) return true;
        return false;
    };

    digitalData = window.digitalData = window.digitalData || [];
    formName = this.elements.parentForm.getAttribute('data-name') || 'default';
    formId = this.elements.parentForm.getAttribute('data-id') || 'default';
    formTitle = this.elements.parentForm.getAttribute('data-title') || 'default';
    formType = this.elements.parentForm.getAttribute('data-type') || 'default';

    /**
     * Update Initial Display
     */
    updateInitialDisplay = () => {
        if(!this.elements.label) return;

        let ele;
        if(this.elements.textInput) ele = this.elements.textInput;
        if(this.elements.textArea) ele = this.elements.textArea;

        // Placeholders
        ele.setAttribute('placeholder', ' ');

        // Set Loaded
        setTimeout(() => this.element.classList.add('loaded'), 350);
    };

    /**
     * On Input Change
     */
    onInputChange = (e) => {
        // Analytics
        sendFormStartEvent(this.formName, this.formId, this.formTitle, this.formType);

        // Update Value
        this.currentValue = e.currentTarget.value;

        // Date Field
        if(e.currentTarget.getAttribute('type') === 'date') e.currentTarget.classList.add('touched');

        // Validation
        if(this.currentValue.trim() === '' && this.isRequired()) {
            this.element.classList.add('error');
        } else {
            this.element.classList.remove('error');
        }
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        if(this.elements.textInput) {
            this.elements.textInput.addEventListener('keyup', this.onInputChange);
            // account for date + number types (change event)
            this.elements.textInput.addEventListener('change', this.onInputChange);
        }

        if(this.elements.textArea) {
            this.elements.textArea.addEventListener('keyup', this.onInputChange);
        }
    };

    /**
     * Initialize Component
     */
    init() {
        // Ensure we have a parent form element
        if(!this.elements.parentForm) return;

        // Init funcs
        this.updateInitialDisplay();
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, FormText);
